// extracted by mini-css-extract-plugin
export default {"chart":"chart-H0uEy","chartContainer":"chartContainer-KiKBt","chartSkeleton":"chartSkeleton-aIvoX","legend":"legend-vC48s","text":"text-YcUiK","label":"label-KOsWO"};